// @owners { team: patients }

export const RATE_SHIPMENT_DISMISSED = 'RATE_SHIPMENT_DISMISSED';

/**
 * Records the uuid of the rating the patient just dismissed so the modal isn't shown again for it.
 * Takes the uuid explicitly (read from the React Query pending rating) now that the pending rating
 * is no longer mirrored into Redux.
 */
export function rateShipmentDismissed(uuid: string | null | undefined) {
  return {
    type: RATE_SHIPMENT_DISMISSED,
    payload: uuid,
  } as const;
}
